import axios from "axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess, loginFailure } from "../authSlice";
import "../styling/Login.css";
import { Link } from "react-router-dom";
import BookingHeader from "./clientPortal/BookingHeader";
// --- 1. Import icons ---
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  // --- 2. Add state for password visibility ---
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    setError(null); // Clear previous errors
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business-user/login`,
        {
          email: email.toLowerCase(),
          password,
        },
        { withCredentials: true }
      );

      const userData = response.data.data;

      const userWithRole = { ...userData, role: "business" };

      // localStorage.setItem("userSession", JSON.stringify(userWithRole));
      dispatch(loginSuccess(userWithRole));

    } catch (error) {
      if (error.response && error.response.status === 403) {
        setError("Invalid Credentials. Please try again!");
      } else {
        setError("An unexpected error occurred. Please try again.");
        dispatch(loginFailure(error.message));
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div>
      <BookingHeader />
      <div className="login-page-container">
        <div className="login-business">
          <div className="login-content">
            <div style={{ fontSize: "24px", color: "#000000", marginBottom: "30px", fontWeight: "bold" }}>
              Login to Boothbloom
            </div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                width: "100%",
                marginBottom: "5px",
                padding: "10px",
                boxSizing: "border-box",
                color: "#625C73"
              }}
            />

            {/* --- 3. Wrap password input AND icon in a relative container --- */}
            {/* This div needs to be relative to position the icon inside it */}
            <div style={{ position: 'relative', width: '100%' }}>
              <input
                name="password"
                placeholder="Password"
                // --- 4. Dynamically set the input type ---
                type={showPassword ? "text" : "password"}
                className="login-input" // Your original class
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                  width: "100%",
                  marginBottom: "5px",
                  padding: "10px",
                  boxSizing: "border-box",
                }}
                // --- Add style to make space for the icon ---
                 // Ensures text doesn't go under the icon
              />
              {/* --- 5. Position the icon toggle button --- */}
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute', 
                  paddingRight: '11px',   // Position it relative to the wrapper
                  right: '0px',           // Adjust horizontal position
                  top: '64%',              // Move it 50% down
                  transform: 'translateY(-50%)', // Center it vertically
                  cursor: 'pointer',       // Show it's clickable
                  color: '#555'             // Optional: style the icon color
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {error && <p style={{ color: "red", marginTop: "10px", textAlign: "center" }}>{error}</p>}

            <button
              className="login-button"
              style={{ width: "100%", marginTop: "15px" }}
              onClick={handleLogin}
            >
              Login
            </button>
            <button
              className="login-button-signup"
              style={{ width: "100%", marginTop: "15px", cursor: "pointer"  }}
              onClick={() => navigate('/signup')}
            >
              Signup
            </button>
            <div style={{ marginTop: "30px" }}>
              <p>
                <Link to="/forgotPassword" style={{ textDecoration: "none" }}>
                <span style={{ textDecoration: "underline", color:"#625C73", fontSize: '12px' }}>
                    Forgot Password?
                  </span>
                </Link>
              </p>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;